import { ArchiSmallServices } from '../../../services/archismall.service';
import { AlertService } from '../../../services/ui/alert.service';

export const RecoverPasswordModalComponent = {
    template: require('./recover-password-modal.html'),
    controller: class RecoverPasswordModalComponent {

        static $inject: string[] = [
            'ArchiSmallServices',
            'AlertService'
        ];

        private userEmail: string;

        private recoveredSuccess: boolean;
        private invalidEmail: boolean;

        private recoverPasswordOnProgress: boolean;

        private close: any;
        private dismiss: any;

        constructor(
            private archiSmallServices: ArchiSmallServices,
            private alertService: AlertService
        ) {
            this.recoveredSuccess = false;
            this.invalidEmail = true;

            this.recoverPasswordOnProgress = false;
        }

        recoverPassword = () => {
            if (!this.recoverPasswordOnProgress) {
                this.recoverPasswordOnProgress = true;
                this.archiSmallServices.recoverPassword({ settings: { option: 0, email: this.userEmail } })
                    .then((response: any) => {
                        if (response.state === 1) {
                            this.recoveredSuccess = true;
                        } else {
                            this.recoveredSuccess = false;
                        }
                        this.recoverPasswordOnProgress = false;
                    }, (error) => {
                        this.alertService.alert('error', error);
                        this.recoveredSuccess = false;
                        this.recoverPasswordOnProgress = false;
                    });
            }
        }

        validateEmail(email: string) {
            if (email === undefined || email === null || email === '') {
                this.invalidEmail = true;
                return;
            }

            this.archiSmallServices.validateEmail(email)
                .then((response: any) => {
                    this.invalidEmail = response;
                }, (error) => {
                    this.alertService.alert('error', error);
                });
        }

        ok() {
            this.close();
        }

        cancel() {
            this.dismiss({ $value: 'cancel' });
        }
    },
    bindings: {
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/login/recover-password-modal/recover-password-modal.component.ts